module.exports = __webpack_public_path__ + "static/media/BannerAlt.5b3400bc.png";